
<div class="top-0 left-0 z-50 h-full w-full bg-black/50 absolute flex justify-center items-center">
    <span class="block h-14 w-14 my-auto fixed inset-0 mx-auto border-2 border-solid border-transparent border-y-white rounded-full animate-spin" />
</div>